import createjs from 'preload-js';
import velocity from 'velocity-animate';

// 使い方参考
// https://ics.media/entry/5239
// http://qiita.com/nakajmg/items/65575d54cbed013ff2a5

export default class Preload {
  constructor() {
    // トップ読込みデータ
    // this.loadData = [
    //   {id:"img1", src:"../assets/images/dummyImg01.jpg"},
    //   {id:"img2", src:"../assets/images/dummyImg02.jpg"},
    //   {id:"img3", src:"../assets/images/dummyImg03.jpg"},
    //   {id:"img4", src:"../assets/images/dummyImg04.jpg"}
    // ];

    // this.bar = document.getElementById('value');

    this.loadData = [];
    this.setLoadData();
    console.log(this.loadData);
    this.init();
  }

  setLoadData() {

    let elms = document.getElementsByTagName('img');
    for (let i = 0; i < elms.length; i++) {
      let item = new Object();
        item.id = "img" + (i+1);
        item.src = elms[i].src;
      this.loadData.push(item);
    }
    console.log(this.loadData.length);

  }

  init() {
    let queue = new createjs.LoadQueue(false);
    queue.on("fileload", this.handleFileComplete);
    queue.on("complete", this.handleComplete);
    queue.on("progress", this.handleProgress);

    queue.loadManifest(this.loadData);
  }


  /* 読み込み状況が変化した際の処理 */
  handleProgress(event) {
    var progress = event.progress;
    document.getElementById('ProgressBar').style.width = progress * 100 + "%";
    // console.log(progress);
    // Velocity(document.getElementById('value'),
    //   {
    //     width: progress * 100 + "%"
    //   },
    //   {
    //     duration: 100
    //   }
    // );
  }


  /* １ファイルを読み込んだ後の処理 */
  handleFileComplete(event) {
    // 読み込んだファイルのIDによって処理を分ける
    // switch(event.item.id) {
    //   case 'img1':
    //     console.log(event.item.id);
    //     break;
    //   case 'img2':
    //     console.log(event.item.id);
    //     break;
    //   case 'img3':
    //     console.log(event.item.id);
    //     break;
    //   case 'img4':
    //     console.log(event.item.id);
    //     break;
    // }

  }

  /* 全ファイルを読み込んだ後の処理 */
  handleComplete() {
    setTimeout(()=> {
      document.getElementById('Progress').style.display = 'none';
      let elm = document.getElementById('Load')
      Velocity(elm,
            {
              opacity: 0
            },
            {
              duration: 400,
              delay: 800,
              ease: 'easeOutExpo',
              complete: () =>{
                elm.style.display = 'none';
              }
            }
          );
    },300)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/components/Preload.js